//#region Imports
import type { IUserSubscriptionStatusDto, IUserSubscriptionStatusRecord } from "@anydo/interfaces";
import {
  assertNullableNumber,
  assertNullableString,
  assertNumber,
  assertString,
  UserSubscriptionStatusRecord,
} from "@anydo/core";
//#endregion

export function getUserSubscriptionStatusFromSubscriptionDto(
  dto: IUserSubscriptionStatusDto | null,
): IUserSubscriptionStatusRecord | null {
  if (dto == null) {
    return null;
  }

  let subscriptionData: IUserSubscriptionStatusRecord["subscriptionData"] | null = null;
  try {
    // TODO: Remove this hack in the future. And create real run-time check
    subscriptionData = JSON.parse(JSON.stringify(dto.subscriptionData)) as
      | IUserSubscriptionStatusRecord["subscriptionData"]
      | null;
  } catch {
    subscriptionData = null;
  }

  const {
    activePlan,
    card_expiration_month: cardExpirationMonth,
    card_expiration_year: cardExpirationYear,
    card_last4: cardLast4,
    paymentProvider,
    planPeriod,
    serverExpirationDate,
    subscriptionDate,
    isReverseTrial,
  } = dto;

  assertNullableString(activePlan);
  assertNullableNumber(cardExpirationMonth);
  assertNullableNumber(cardExpirationYear);
  assertNullableString(cardLast4);
  assertString(paymentProvider);
  assertNullableString(planPeriod);
  assertNumber(serverExpirationDate);
  assertNumber(subscriptionDate);

  return UserSubscriptionStatusRecord.create({
    activePlan,
    cardExpirationMonth,
    cardExpirationYear,
    cardLast4,
    isCanceled: Boolean(dto.isCanceled),
    paymentProvider,
    planPeriod,
    serverExpirationDate,
    subscriptionData,
    subscriptionDate,
    isReverseTrial,
  });
}
